exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-icon{width:100%;height:100%;margin:auto}.scrollable-box{max-height:60vh;overflow-y:scroll}.db-field{margin-left:15px;margin-bottom:15px;margin-top:15px}", ""]);

// exports
